import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import fetch from "cross-fetch";

const cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                creatorProfileDetailByUsername: {
                    keyArgs: ["id"]
                }
            }
        }
    }
});

const client = new ApolloClient({
    ssrMode: false,
    link: createHttpLink({
        uri: window._nounConfig.graphqlEndpoint,
        credentials: "include",
        fetch
    }),
    cache
});

export default client;
